import { sendGet, sendPost } from './axios';

export const getTargetProfile = (id) => sendGet(`/user/${id}`);

export const viewTargetProfile = (id) => sendPost(`/user/view-profile/${id}`);

export const getLikeTarget = (id) => sendGet(`/like/${id}`);

export const createLike = (payload) => sendPost(`/like`, payload);

export const getConversationTarget = (targetId) => sendGet(`/conversation/user/${targetId}`);

export const createConversation = (targetId) => sendPost(`/conversation/user/${targetId}`);

export const createBlog = (payload) => sendPost(`/block`, payload);

export const createFavorite = (payload) => sendPost(`/favorite`, payload);

export const createReport = (payload) => sendPost(`/report`, payload);

export const createAppointment = (payload) => sendPost(`/create-appointment`, payload);

export const sendGift = (payload) => sendPost(`/send-gift-point`, payload);

export const getAppointmentToTarget = (id) => sendPost(`/appointment/${id}`);

export const createTwilioHistory = (payload) => sendPost(`/create-twilio-history`, payload);

export const pointUsage = (payload) => sendPost(`/user/point/usage`, payload);

export const sendSmsUser = (payload) => sendPost(`/cms/send-sms-user/${payload.id}`, { data: payload.data });

export const chatSupport = (senderId) => sendPost('/chat-support/create-conversation', {senderId})

export const chatAgent = (senderId, agentId) => sendPost('/chat-agent/create-conversation', {senderId, agentId})